import { createClient } from "@sanity/client";

/**
 * Read-only Sanity client with CDN enabled.
 * Use this for all public read operations (fetching products, pages, etc.)
 * CDN caching significantly reduces bandwidth usage.
 */
export const sanityClient = createClient({
  projectId: "3hfttlve",
  dataset: "production",
  useCdn: true,
  apiVersion: "v1",
});

/**
 * Write-enabled Sanity client (no CDN, with token).
 * Use this ONLY for mutations (updating product quantities, etc.)
 * This client bypasses CDN to ensure fresh data for write operations.
 */
export const sanityWriteClient = createClient({
  projectId: "3hfttlve",
  dataset: "production",
  useCdn: false,
  apiVersion: "v1",
  //protect this token via environment variables or netlify variables
  token: process.env.REACT_APP_SANITY_TOKEN,
});

// Default export for backwards compatibility (read client)
export default sanityClient;

export const tokens = {
  emailjs_init: process.env.REACT_APP_EMAILJS_INIT,
  emailjs_service_id: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  emailjs_template_id_client: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CLIENT,
  emailjs_template_id_summary: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_STORE_OWNER,
  firebase_api_key: process.env.REACT_APP_FIREBASE_API_KEY,
  firebase_auth_domain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  firebase_project_id: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebase_storage_bucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  firebase_messaging_sender_id: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  firebase_app_id: process.env.REACT_APP_FIREBASE_APP_ID,
};
